export default __webpack_public_path__ + "static/media/clock-orange.9589237c.svg";